module.exports = __webpack_public_path__ + "web/img/z6.c676b9a3.png";